import axios from "axios";
//import FormData from "form-data";
import {AdminGCViewDataEndPoint} from "../../../config/AppServerConfig";
import {GlobalConfig} from "./../../../Services/Helper/GlobalConfig";

// axios.interceptors.response.use((response) => {
//     return response;
// }, function (error) {
//     return Promise.reject(error.response);
// });

class AdminGCDataViewServices {
    static getAdminGCDataView(gcId) {

        const config = {
            headers: {"Authorization": GlobalConfig.Token}
        };
        return axios.get(AdminGCViewDataEndPoint +  gcId+"/data", config);
    }

}
export {AdminGCDataViewServices};
